import axios from "axios";
import {REQUEST_URL} from '../config/urls.js';

export const getPrecoArtes = async ()=>{
  let response = await axios.get(`${REQUEST_URL}/orcamentos/preco_arte`);
  return response.status === 200 ? response.data : [];
}
